/* La Pénombre · le Masque du soir en 3D (Three.js r147). Variante « Journal » (15/10/2026) :
   décor parchemin et pervenche, sans pétales ; le masque lui-même ne change pas.
   Le modèle est construit ici, en code, d'après la photo du fabricant (Sourcing/reference-produit-fournisseur.png) :
   silicone noire, losanges dorés, ouvertures des yeux, du nez et des lèvres, attaches sur les côtés,
   câble et télécommande. Aucune image générée. Coloris à confirmer sur l'échantillon.
   La lumière suit l'attribut data-lumiere de la scène (boutons gérés par petale.js).
   Sans WebGL, les photos de la carte restent affichées. */
(function () {
  var scene = document.querySelector('[data-scene]');
  var zone = scene && scene.querySelector('[data-3d]');
  if (!zone || !window.THREE) return;
  var T = window.THREE;
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var petitEcran = window.innerWidth < 640;

  /* ---------- Moteur ---------- */
  var toile = document.createElement('canvas'), rendu;
  try { rendu = new T.WebGLRenderer({ canvas: toile, antialias: true, alpha: true, powerPreference: 'high-performance' }); } catch (e) { return; }
  if (!rendu.getContext()) return;
  toile.className = 'toile-3d';
  toile.setAttribute('role', 'img');
  toile.setAttribute('aria-label', 'Le Masque du soir en 3D. Faites-le tourner avec la souris, le doigt ou les flèches du clavier.');
  toile.tabIndex = 0;
  zone.appendChild(toile);
  rendu.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  rendu.outputEncoding = T.sRGBEncoding;
  /* rendu linéaire : garde le bleu et le rouge francs (l'ACES les blanchissait) */
  rendu.toneMapping = T.LinearToneMapping;
  rendu.toneMappingExposure = 0.95;

  var monde = new T.Scene();
  var camera = new T.PerspectiveCamera(30, 1, 0.1, 40);
  camera.position.set(0, 0.04, 3.0);
  camera.lookAt(0, -0.12, 0);

  var toileDessin = function (l, h) { var c = document.createElement('canvas'); c.width = l; c.height = h; return c; };
  var texture = function (c, couleur) {
    var t = new T.CanvasTexture(c);
    if (couleur) t.encoding = T.sRGBEncoding;
    t.anisotropy = Math.min(8, rendu.capabilities.getMaxAnisotropy());
    return t;
  };

  /* ---------- Environnement doux pour les reflets (rose et blanc, pas de noir) ---------- */
  (function () {
    var c = toileDessin(16, 256), x = c.getContext('2d'), g = x.createLinearGradient(0, 0, 0, 256);
    g.addColorStop(0, '#ffffff'); g.addColorStop(.45, '#f3efec'); g.addColorStop(1, '#d6d0cc');
    x.fillStyle = g; x.fillRect(0, 0, 16, 256);
    var env = new T.Scene();
    env.add(new T.Mesh(new T.SphereGeometry(10, 32, 16), new T.MeshBasicMaterial({ map: texture(c, true), side: T.BackSide })));
    var panneau = function (l, h, couleur, pos) {
      var m = new T.Mesh(new T.PlaneGeometry(l, h), new T.MeshBasicMaterial({ color: couleur, side: T.DoubleSide }));
      m.position.copy(pos); m.lookAt(0, 0, 0); env.add(m);
    };
    panneau(5, 3, new T.Color(3.2, 3.1, 3.0), new T.Vector3(1.5, 6, 5));
    panneau(3, 4, new T.Color(1.9, 2.0, 2.3), new T.Vector3(-7, 1, 2));
    var pm = new T.PMREMGenerator(rendu);
    monde.environment = pm.fromScene(env, 0.04).texture;
    pm.dispose();
  })();

  /* ---------- Lumières ---------- */
  monde.add(new T.HemisphereLight(0xf6f3f1, 0xcecac8, 0.85));
  var cle = new T.DirectionalLight(0xfff3ea, 1.35); cle.position.set(2.2, 2.6, 3.2); monde.add(cle);
  var contre = new T.DirectionalLight(0xa0b5eb, 1.1); contre.position.set(-3, 1.2, -2.4); monde.add(contre);

  /* ---------- Dessin du masque (canevas 1000 × 1200 = 1,00 × 1,20 unité) ---------- */
  var L = 1000, H = 1200;
  var arrondi = function (x, gx, gy, l, h, r) {
    x.moveTo(gx + r, gy); x.lineTo(gx + l - r, gy); x.quadraticCurveTo(gx + l, gy, gx + l, gy + r);
    x.lineTo(gx + l, gy + h - r); x.quadraticCurveTo(gx + l, gy + h, gx + l - r, gy + h);
    x.lineTo(gx + r, gy + h); x.quadraticCurveTo(gx, gy + h, gx, gy + h - r);
    x.lineTo(gx, gy + r); x.quadraticCurveTo(gx, gy, gx + r, gy); x.closePath();
  };
  var silhouette = function (x) {
    x.beginPath();
    x.moveTo(250, 50); x.lineTo(750, 50); x.quadraticCurveTo(870, 50, 872, 170);
    x.lineTo(860, 900); x.quadraticCurveTo(855, 1060, 720, 1120); x.quadraticCurveTo(500, 1192, 280, 1120);
    x.quadraticCurveTo(145, 1060, 140, 900); x.lineTo(128, 170); x.quadraticCurveTo(130, 50, 250, 50); x.closePath();
    /* attaches des sangles, deux de chaque côté */
    arrondi(x, 58, 470, 100, 92, 26); arrondi(x, 58, 760, 100, 92, 26);
    arrondi(x, 842, 470, 100, 92, 26); arrondi(x, 842, 760, 100, 92, 26);
  };
  var nez = function (x) { x.beginPath(); x.moveTo(500, 498); x.lineTo(566, 690); x.quadraticCurveTo(570, 700, 558, 700); x.lineTo(442, 700); x.quadraticCurveTo(430, 700, 434, 690); x.closePath(); };
  var levres = function (x) {
    x.beginPath(); x.moveTo(398, 818);
    x.bezierCurveTo(438, 782, 470, 778, 500, 794); x.bezierCurveTo(530, 778, 562, 782, 602, 818);
    x.bezierCurveTo(560, 866, 440, 866, 398, 818); x.closePath();
  };
  var ouvertures = function (x) {
    x.beginPath(); x.ellipse(345, 455, 94, 55, 0.07, 0, Math.PI * 2); x.fill();
    x.beginPath(); x.ellipse(655, 455, 94, 55, -0.07, 0, Math.PI * 2); x.fill();
    nez(x); x.fill(); levres(x); x.fill();
    x.beginPath(); arrondi(x, 455, 84, 90, 26, 13); x.fill();
    [[76, 496], [76, 786], [892, 496], [892, 786]].forEach(function (p) { x.beginPath(); arrondi(x, p[0], p[1], 32, 40, 12); x.fill(); });
  };

  /* forme : blanc = matière, noir = vide (sert de masque de transparence) */
  var cForme = toileDessin(L, H), xf = cForme.getContext('2d');
  xf.fillStyle = '#000'; xf.fillRect(0, 0, L, H);
  xf.fillStyle = '#fff'; silhouette(xf); xf.fill();
  xf.fillStyle = '#000'; ouvertures(xf);
  var pixels = xf.getImageData(0, 0, L, H).data;
  var plein = function (px, py) { px = Math.round(px); py = Math.round(py); return px >= 0 && py >= 0 && px < L && py < H && pixels[(py * L + px) * 4] > 128; };

  /* treillis de losanges : intersections tous les 48 px, en quinconce */
  var points = [];
  for (var j = 0; j <= 17; j++) for (var i = -9; i <= 9; i++) {
    if ((i + j) % 2) continue;
    var px = 500 + i * 48, py = 222 + j * 48;
    if (py > 1040) continue;
    if (plein(px, py) && plein(px + 12, py) && plein(px - 12, py) && plein(px, py + 12) && plein(px, py - 12)) points.push([px, py]);
  }
  var etoile = function (x, cx, cy, r) {
    x.beginPath();
    for (var k = 0; k < 8; k++) {
      var a = k * Math.PI / 4 - Math.PI / 2, rr = k % 2 ? r * .28 : r;
      x.lineTo(cx + Math.cos(a) * rr, cy + Math.sin(a) * rr);
    }
    x.closePath();
  };

  /* couleur : silicone noire mate, filets et étoiles dorés */
  var cCouleur = toileDessin(L, H), xc = cCouleur.getContext('2d');
  var fond = xc.createLinearGradient(0, 0, 0, H); fond.addColorStop(0, '#26201f'); fond.addColorStop(1, '#17121a');
  xc.fillStyle = fond; xc.fillRect(0, 0, L, H);
  for (var n = 0; n < 9000; n++) { xc.fillStyle = Math.random() < .5 ? 'rgba(255,255,255,.035)' : 'rgba(0,0,0,.06)'; xc.fillRect(Math.random() * L, Math.random() * H, 2, 2); }
  xc.save(); xc.beginPath(); xc.rect(0, 200, L, 860); xc.clip();
  xc.strokeStyle = 'rgba(190,140,58,.6)'; xc.lineWidth = 2.2;
  for (var d = -1400; d < 2400; d += 96) {
    xc.beginPath(); xc.moveTo(d, 222 - 48 * 2); xc.lineTo(d + 1300, 222 - 96 + 1300); xc.stroke();
    xc.beginPath(); xc.moveTo(d, 222 - 48 * 2); xc.lineTo(d - 1300, 222 - 96 + 1300); xc.stroke();
  }
  xc.restore();
  xc.strokeStyle = 'rgba(0,0,0,.35)'; xc.lineWidth = 3;
  [200, 1060].forEach(function (y) { xc.beginPath(); xc.moveTo(0, y); xc.lineTo(L, y); xc.stroke(); });
  points.forEach(function (p) {
    var g = xc.createRadialGradient(p[0], p[1], 1, p[0], p[1], 14); g.addColorStop(0, '#ffe2a0'); g.addColorStop(1, '#c48a2c');
    xc.fillStyle = g; etoile(xc, p[0], p[1], 14); xc.fill();
  });
  /* liseré clair autour du nez, comme sur la photo du fabricant */
  xc.strokeStyle = 'rgba(235,228,220,.85)'; xc.lineWidth = 7; xc.lineJoin = 'round'; nez(xc); xc.stroke();

  /* lumière : les points de LED (blanc), la couleur vient du matériau */
  var cLum = toileDessin(L, H), xl = cLum.getContext('2d');
  xl.fillStyle = '#000'; xl.fillRect(0, 0, L, H);
  points.forEach(function (p) {
    var g = xl.createRadialGradient(p[0], p[1], 0, p[0], p[1], 20); g.addColorStop(0, '#fff'); g.addColorStop(.35, 'rgba(255,255,255,.75)'); g.addColorStop(1, 'rgba(255,255,255,0)');
    xl.fillStyle = g; xl.fillRect(p[0] - 20, p[1] - 20, 40, 40);
    xl.fillStyle = '#fff'; etoile(xl, p[0], p[1], 15); xl.fill();
  });
  xl.strokeStyle = '#fff'; xl.lineWidth = 9; xl.lineJoin = 'round'; nez(xl); xl.stroke();
  xl.lineWidth = 6; levres(xl); xl.stroke();

  var texForme = texture(cForme, false), texCouleur = texture(cCouleur, true), texLum = texture(cLum, true);

  /* ---------- Géométrie : une plaque courbée autour du visage ---------- */
  var R = 0.52;
  var courber = function (x, y, retrait) {
    var a = x / R, r = R - retrait;
    var px = r * Math.sin(a), pz = r * Math.cos(a) - R;
    pz -= 0.2 * y * y;
    pz += 0.065 * Math.exp(-((x * x) / 0.0064 + (y * y) / 0.032));                       /* arête du nez */
    pz += 0.022 * Math.exp(-(((Math.abs(x) - 0.17) * (Math.abs(x) - 0.17)) / 0.012 + ((y - 0.03) * (y - 0.03)) / 0.006)); /* pommettes */
    pz += 0.03 * Math.exp(-((x * x) / 0.05 + ((y + 0.5) * (y + 0.5)) / 0.02));            /* menton */
    return [px, y, pz];
  };
  var plaque = function (retrait) {
    var g = new T.PlaneGeometry(1, 1.2, 96, 120), pos = g.attributes.position;
    for (var k = 0; k < pos.count; k++) {
      var v = courber(pos.getX(k), pos.getY(k), retrait);
      pos.setXYZ(k, v[0], v[1], v[2] - retrait * .4);
    }
    g.computeVertexNormals();
    return g;
  };

  var groupe = new T.Group(); monde.add(groupe);       /* flotte doucement */
  var masque = new T.Group(); groupe.add(masque);      /* tourne à la souris */
  groupe.position.y = 0.06;

  var matiere = new T.MeshStandardMaterial({ map: texCouleur, alphaMap: texForme, alphaTest: 0.5, side: T.DoubleSide, roughness: 0.62, metalness: 0.06, envMapIntensity: 0.5, emissive: new T.Color(0x000000), emissiveMap: texLum, emissiveIntensity: 0 });
  masque.add(new T.Mesh(plaque(0), matiere));
  var dos = new T.Mesh(plaque(0.016), new T.MeshStandardMaterial({ color: 0x0f0b0d, alphaMap: texForme, alphaTest: 0.5, side: T.DoubleSide, roughness: 0.85 }));
  masque.add(dos);

  /* halos des LED (au-dessus de chaque point) */
  var cHalo = toileDessin(128, 128), xh = cHalo.getContext('2d'), gh = xh.createRadialGradient(64, 64, 0, 64, 64, 64);
  gh.addColorStop(0, 'rgba(255,255,255,1)'); gh.addColorStop(.25, 'rgba(255,255,255,.55)'); gh.addColorStop(1, 'rgba(255,255,255,0)');
  xh.fillStyle = gh; xh.fillRect(0, 0, 128, 128);
  var texHalo = texture(cHalo, true);
  var matLed = new T.SpriteMaterial({ map: texHalo, color: 0x3d6bff, transparent: true, opacity: 0, blending: T.AdditiveBlending, depthWrite: false });
  points.forEach(function (p) {
    var x = p[0] / L - .5, y = .6 - p[1] / L, v = courber(x, y, 0), a = x / R;
    var s = new T.Sprite(matLed);
    s.position.set(v[0] + Math.sin(a) * .012, v[1], v[2] + Math.cos(a) * .012);
    s.scale.setScalar(.05);
    masque.add(s);
  });
  var lampe = new T.PointLight(0x3d6bff, 0, 2.6, 2); lampe.position.set(0, -0.05, 0.55); masque.add(lampe);

  /* câble et télécommande */
  var depart = courber(-0.40, -0.205, 0);
  var cable = new T.CatmullRomCurve3([
    new T.Vector3(depart[0] - .02, depart[1], depart[2] - .01), new T.Vector3(-.52, -.42, -.12),
    new T.Vector3(-.42, -.70, .12), new T.Vector3(-.16, -.80, .27), new T.Vector3(-.04, -.80, .30)
  ]);
  var caoutchouc = new T.MeshStandardMaterial({ color: 0x0d0a0b, roughness: 0.7, metalness: 0.02, envMapIntensity: 0.25 });
  masque.add(new T.Mesh(new T.TubeGeometry(cable, 80, 0.011, 10, false), caoutchouc));
  var telecommande = new T.Group();
  var corps = new T.Mesh(new T.CapsuleGeometry(0.052, 0.17, 12, 24), new T.MeshStandardMaterial({ color: 0x141012, roughness: 0.4, metalness: 0.08, envMapIntensity: 0.35 }));
  corps.rotation.z = Math.PI / 2; corps.scale.set(1, 1, .5); telecommande.add(corps);
  var bouton = new T.Mesh(new T.CylinderGeometry(0.024, 0.024, 0.012, 32), new T.MeshStandardMaterial({ color: 0x241e21, roughness: 0.35, envMapIntensity: 0.35 }));
  bouton.position.set(0.01, 0.03, 0); telecommande.add(bouton);
  var temoin = new T.Mesh(new T.SphereGeometry(0.006, 12, 8), new T.MeshStandardMaterial({ color: 0xff3b3b, emissive: 0xff2020, emissiveIntensity: 2 }));
  temoin.position.set(-0.07, 0.026, 0); telecommande.add(temoin);
  telecommande.position.set(0.1, -0.8, 0.3); telecommande.rotation.set(0, -0.35, 0);
  masque.add(telecommande);

  /* ombre douce au sol */
  var cOmbre = toileDessin(128, 128), xo = cOmbre.getContext('2d'), go = xo.createRadialGradient(64, 64, 0, 64, 64, 64);
  go.addColorStop(0, 'rgba(36,36,36,.32)'); go.addColorStop(1, 'rgba(36,36,36,0)'); xo.fillStyle = go; xo.fillRect(0, 0, 128, 128);
  var ombre = new T.Mesh(new T.PlaneGeometry(1.7, 0.75), new T.MeshBasicMaterial({ map: texture(cOmbre, true), transparent: true, depthWrite: false }));
  ombre.rotation.x = -Math.PI / 2; ombre.position.set(0, -0.9, 0.05); monde.add(ombre);

  /* grand halo coloré derrière le masque */
  var halo = new T.Sprite(new T.SpriteMaterial({ map: texHalo, color: 0xcfdaf5, transparent: true, opacity: .5, depthWrite: false }));
  halo.scale.set(2.3, 2.3, 1); halo.position.set(0, -0.08, -0.7); monde.add(halo);

  /* ---------- Perles nacrées qui tournent autour ---------- */
  var nacre = new T.MeshPhysicalMaterial({ color: 0xf3efec, roughness: 0.22, metalness: 0, clearcoat: 1, clearcoatRoughness: 0.1, sheen: 0.35, sheenColor: new T.Color(0xffffff), iridescence: 0.5, iridescenceIOR: 1.3, envMapIntensity: 0.55 });
  var nacrePeche = nacre.clone(); nacrePeche.color.set(0xcfdaf5);
  var perles = [];
  [[.07, .95, .25, 0, .35], [.05, .85, -.35, 2.1, .28], [.09, 1.05, .05, 4.0, .22], [.04, .78, .45, 5.2, .4], [.06, .9, -.6, 1.2, .3]].forEach(function (p, k) {
    var m = new T.Mesh(new T.SphereGeometry(p[0], 40, 24), k % 2 ? nacrePeche : nacre);
    monde.add(m); perles.push({ m: m, r: p[1], h: p[2], a: p[3], v: p[4] });
  });

  /* ---------- Pétales en 3D ---------- */
  var cPetale = toileDessin(64, 76), xp = cPetale.getContext('2d'), gp = xp.createRadialGradient(32, 66, 2, 32, 40, 44);
  gp.addColorStop(0, '#e48ba2'); gp.addColorStop(.55, '#f7cbd5'); gp.addColorStop(1, '#fff3f5');
  xp.fillStyle = gp; xp.beginPath(); xp.moveTo(32, 74); xp.bezierCurveTo(6, 54, 0, 26, 13, 10); xp.bezierCurveTo(19, 1, 28, 3, 32, 12); xp.bezierCurveTo(36, 3, 45, 1, 51, 10); xp.bezierCurveTo(64, 26, 58, 54, 32, 74); xp.fill();
  var nbPetales = 0;
  var petales = new T.InstancedMesh(new T.PlaneGeometry(0.055, 0.065), new T.MeshStandardMaterial({ map: texture(cPetale, true), alphaTest: 0.4, side: T.DoubleSide, roughness: 0.7, emissive: 0xffd6df, emissiveIntensity: 0.25 }), Math.max(nbPetales, 1));
  petales.visible = nbPetales > 0; monde.add(petales);
  var infos = [], modele = new T.Object3D();
  for (var q = 0; q < nbPetales; q++) infos.push({ x: Math.random() * 3 - 1.5, y: Math.random() * 2.6 - 1.1, z: Math.random() * 1.6 - 1, v: .12 + Math.random() * .14, o: Math.random() * 6.3, rx: Math.random() * 6, rz: Math.random() * 6, s: .7 + Math.random() * .6 });

  /* ---------- La lumière choisie ---------- */
  var COULEURS = { eteint: null, bleu: new T.Color(0x1f4dff), rouge: new T.Color(0xff1a1a) };
  var HALOS = { eteint: new T.Color(0xcfdaf5), bleu: new T.Color(0x9db4ff), rouge: new T.Color(0xff9a9a) };
  var cible = { intensite: 0, couleur: new T.Color(0x3f6dff), halo: new T.Color(0xcfdaf5), haloOpacite: .5 };
  var choisir = function (nom) {
    var c = COULEURS[nom];
    cible.intensite = c ? 1.1 : 0;
    if (c) cible.couleur.copy(c);
    cible.halo.copy(HALOS[nom] || HALOS.eteint);
    cible.haloOpacite = c ? .62 : .5;
    if (reduit) appliquer(1);
  };
  var appliquer = function (k) {
    matiere.emissiveIntensity += (cible.intensite - matiere.emissiveIntensity) * k;
    matiere.emissive.lerp(cible.couleur, k);
    matLed.color.lerp(cible.couleur, k);
    matLed.opacity += ((cible.intensite > 0 ? .6 : 0) - matLed.opacity) * k;
    lampe.color.lerp(cible.couleur, k);
    lampe.intensity += ((cible.intensite > 0 ? 1.4 : 0) - lampe.intensity) * k;
    halo.material.color.lerp(cible.halo, k);
    halo.material.opacity += (cible.haloOpacite - halo.material.opacity) * k;
  };
  choisir(scene.getAttribute('data-lumiere') || 'eteint'); appliquer(1);
  new MutationObserver(function () { choisir(scene.getAttribute('data-lumiere')); }).observe(scene, { attributes: true, attributeFilter: ['data-lumiere'] });

  /* ---------- Faire tourner : souris, doigt, clavier ---------- */
  var BASE = -0.5, lacet = BASE, tangage = 0.08, cLacet = lacet, cTangage = tangage, dernierGeste = -99, glisse = null;
  var maintenant = function () { return performance.now() / 1000; };
  var geste = function () { dernierGeste = maintenant(); scene.classList.add('scene-touchee'); };
  toile.addEventListener('pointerdown', function (e) { glisse = { x: e.clientX, y: e.clientY }; toile.setPointerCapture(e.pointerId); geste(); });
  toile.addEventListener('pointermove', function (e) {
    if (!glisse) return;
    cLacet += (e.clientX - glisse.x) * 0.01;
    cTangage = Math.max(-0.45, Math.min(0.45, cTangage + (e.clientY - glisse.y) * 0.005));
    glisse = { x: e.clientX, y: e.clientY }; geste();
  });
  var lacher = function () { glisse = null; };
  toile.addEventListener('pointerup', lacher); toile.addEventListener('pointercancel', lacher);
  toile.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') cLacet -= .25; else if (e.key === 'ArrowRight') cLacet += .25;
    else if (e.key === 'ArrowUp') cTangage = Math.max(-0.45, cTangage - .12); else if (e.key === 'ArrowDown') cTangage = Math.min(0.45, cTangage + .12);
    else return;
    e.preventDefault(); geste();
  });

  /* ---------- Taille et boucle d'affichage (arrêtée hors écran) ---------- */
  var taille = function () {
    var l = zone.clientWidth, h = zone.clientHeight;
    if (!l || !h) return;
    rendu.setSize(l, h, false); camera.aspect = l / h; camera.updateProjectionMatrix();
  };
  taille();
  if ('ResizeObserver' in window) new ResizeObserver(taille).observe(zone); else window.addEventListener('resize', taille);
  var visible = true;
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) boucle(); }).observe(zone);

  var avant = maintenant(), enCours = false;
  var image = function () {
    var t = maintenant(), dt = Math.min(0.1, t - avant); avant = t;
    if (!reduit) {
      if (!glisse && t - dernierGeste > 3) { cLacet += (BASE + Math.sin(t * 0.35) * 0.42 - cLacet) * 0.02; cTangage += (0.07 + Math.sin(t * 0.5) * 0.05 - cTangage) * 0.02; }
      groupe.position.y = 0.06 + Math.sin(t * 0.9) * 0.025;
      ombre.material.opacity = 0.9 - Math.sin(t * 0.9) * 0.15;
      perles.forEach(function (p) {
        p.a += p.v * dt;
        p.m.position.set(Math.cos(p.a) * p.r, p.h + Math.sin(t * .8 + p.a) * .05, Math.sin(p.a) * p.r * .55);
      });
      for (var k = 0; k < infos.length; k++) {
        var f = infos[k];
        f.y -= f.v * dt; if (f.y < -1.15) { f.y = 1.3; f.x = Math.random() * 3 - 1.5; }
        modele.position.set(f.x + Math.sin(t * .7 + f.o) * .12, f.y, f.z);
        modele.rotation.set(f.rx + t * .9, t * .5 + f.o, f.rz + t * .6);
        modele.scale.setScalar(f.s); modele.updateMatrix(); petales.setMatrixAt(k, modele.matrix);
      }
      if (infos.length) petales.instanceMatrix.needsUpdate = true;
    } else {
      perles.forEach(function (p) { p.m.position.set(Math.cos(p.a) * p.r, p.h, Math.sin(p.a) * p.r * .55); });
    }
    /* fondus réglés sur le temps, pas sur la vitesse de l'ordinateur */
    var kRot = reduit ? 1 : 1 - Math.exp(-dt * 6), kLum = reduit ? 1 : 1 - Math.exp(-dt * 3.5);
    lacet += (cLacet - lacet) * kRot;
    tangage += (cTangage - tangage) * kRot;
    masque.rotation.set(tangage, lacet, 0);
    appliquer(kLum);
    rendu.render(monde, camera);
  };
  var boucle = function () {
    if (enCours) return; enCours = true;
    var pas = function () {
      if (!visible || document.hidden) { enCours = false; return; }
      image(); requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) boucle(); });

  image();
  scene.classList.add('scene-3d-pret');
  var mention = scene.querySelector('[data-mention]');
  if (mention) mention.textContent = 'Modèle 3D indicatif';
  boucle();
})();
